var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"true","data-backdrop":_vm.backdrop}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }